<template lang="pug">
  #owner
    //- .info
    //-   .bottons
    //-     el-button(@click="openUpdateDialog" icon="el-icon-edit" size="mini")
    //-     template(v-if="owner.is_active")
    //-       el-button(@click="isShowingOwnerDisableDialog=true" icon="el-icon-error" size="mini" type="danger")
    //-     template(v-else)
    //-       el-button(@click="isShowingOwnerDisableDialog=true" icon="el-icon-success" size="mini" type="success")

    .profile
      p.type(v-if="showType(owner.type)") {{ showType(owner.type) }}
      h1
        ruby {{ owner.name }}
          rt {{ owner.name_kana }}
      p.status {{ $t('Owners.company.is_active') }}:
        el-tag(:type="makeStatusCss(owner.is_active)" size="small") {{ showStatus(owner.is_active) }}
      p.notes {{ owner.notes }}
    .basic
      h2 {{ $t('Owners.company.basic_info') }}
      p.humanized_id
        span.label {{ $t('Owners.company.humanized_id') }}
        span.value {{ owner.humanized_id }}
      template(v-if="owner.type == 'normal' && owner.distributor != null")
        p.distributor_humanized_id
          span.label {{ $t('Owners.company.distributor') }}
          span.value {{ owner.distributor.name }}
      p.zip_code
        span.label {{ $t('Owners.company.zip_code') }}
        span.value {{ owner.zip_code }}
      p.address
        span.label {{ $t('Owners.company.address') }}
        span.value {{ owner.address }}
      p.currency
        span.label {{ $t('Owners.company.currency_setting') }}
        span.value {{ owner.currency }}
      p.phone_number
        span.label {{ $t('Owners.company.phone_number') }}
        span.value {{ owner.phone_number }}
      p.fax_number
        span.label {{ $t('Owners.company.fax_number') }}
        span.value {{ owner.fax_number }}
      p.timezone_tzinfo_ident
        span.label {{ $t('Owners.company.timezone') }}
        span.value {{ owner.timezone_tzinfo_ident }}

    .cuona
      h2 {{ $t('Owners.company.cuona_info') }}
      p.firmware
        span.label {{ $t('Owners.company.cube_firmware') }}
        span.value {{ showFirmware(owner.firmware) }}
      p.num_cube_devices
        span.label {{ $t('Owners.company.cube_num') }}
        span.value {{ owner.num_cube_devices }}
      p.num_tag_devices
        span.label {{ $t('Owners.company.tag_num') }}
        span.value {{ owner.num_tag_devices }}

    .other
      h2 {{ $t('Owners.company.other_info') }}
      p.sdk_token
        span.label {{ $t('Owners.company.sdk_token') }}
        span.value {{ owner.sdk_token }}
      p.key_code
        span.label {{ $t('Owners.company.key_code') }}
        span.value {{ owner.key_code }}
      template(v-if="user.company.type == 'admin'")
        p.stripe_customer_id
          span.label {{ $t('Owners.company.stripe_payment') }}
          span.value {{ showStripeEnabled(owner.stripe_customer_id) }}
        p.device_password
          span.label {{ $t('Owners.company.device_password') }}
          span.value {{ owner.device_password }}

</template>

<script>
import API from '@/api/v2/users'
import CUBEAPI from '@/api/cuona'
import ownerTypes from '@/utils/defines/owner'

export default {
  mixins: [ownerTypes],
  data () {
    const checkPassword = (rule, value, callback) => {
      var re = /^[A-Za-z0-9!"#$%&'()\*\+\-\.,\/:;<=>?@\[\\\]^_`{|}~]*$/
      if (re.test(value)) {
        callback();
      } else {
        callback(new Error(this.$t('Owners.input_password_error')));
      }
    };
    const checkZipcode = (rule, value, callback) => {
      var re = /^[0-9]*$/
      if (re.test(value)) {
        if (value.length === 7) {
          callback();
        } else {
          callback(new Error(this.$t('Owners.input_length7_error')));
        }
      } else {
        callback(new Error(this.$t('Owners.input_number_error')));
      }
    };
    return {
      isLoading: true,
      isShowingOwnerDisableDialog: false,
      openUpdateDialog: false,
      owner: [],
      timezones: [],
      dialogForm: {
        company: {
          name: '',
          type: 'normal',
          zip_code: null,
          address: '',
          timezone_tzinfo_ident: '',
          invoice_email: '',
          currency: 'JPY'
        },
        owner: {
          name: '',
          email: '',
          password: ''
        }
      },
      rules: {
        company: {
          type: [
            { required: true, message: this.$t('Owners.select_blank_error'),trigger: 'change' }
          ],
          name: [
            { required: true, message: this.$t('Owners.input_blank_error'), trigger: 'blur' }
          ],
          zip_code: [
            { required: true, message: this.$t('Owners.input_blank_error'), trigger: 'blur' },
            { validator: checkZipcode, trigger: 'blur' }
          ],
          address: [
            { required: true, message: this.$t('Owners.input_blank_error'), trigger: 'blur' }
          ],
          timezone_tzinfo_ident: [
            { required: true, message: this.$t('Owners.select_blank_error'), trigger: 'change' }
          ],
          invoice_email: [
            { required: true, message: this.$t('Owners.input_blank_error'), trigger: 'blur' },
            { type: 'email', message: this.$t('Owners.input_email_error'), trigger: 'blur' }
          ]
        },
        owner: {
          name: [
            { required: true, message: this.$t('Owners.input_blank_error'), trigger: 'blur' }
          ],
          email: [
            { required: true, message: this.$t('Owners.input_blank_error'), trigger: 'blur' },
            { type: 'email', message: this.$t('Owners.input_email_error'), trigger: 'blur' }
          ],
          password: [
            { required: true, message: this.$t('Owners.input_blank_error'), trigger: 'blur' },
            { min: 8, max: 64, message: this.$t('Owners.input_password_length8_error'), trigger: 'blur' },
            { validator: checkPassword, trigger: 'blur' }
          ]
        }
      }
    }
  },
  mounted() {
    this.loadOwner(this.$store.state.user.user.company.type, this.$route.params.id);
  },
  computed: {
    user: function() {
      return this.$store.state.user.user
    }
  },
  methods: {
    //オーナー情報取得
    loadOwner: function(type, id) {
      const _this = this
      API.getCompany(type, id)
        .then(function (response) {
          _this.owner = response.company
          _this.isLoading = false
        })
    },
    showStatus(is_active) {
      return is_active ? this.$t('Owners.company.active') : this.$t('Owners.company.deactive')
    },
    showStripeEnabled(enabled) {
      return (enabled == null || enabled.length < 12) ? this.$t('Owners.company.deactive') : this.$t('Owners.company.active')
    },
    showFirmware(firmwareObject) {
      return firmwareObject ? firmwareObject.version : this.$t('Owners.company.latest_firmware');
    },
    makeStatusCss(is_active) {
      return is_active ? 'success' : 'danger'
    }
  },
  watch : {
    owner : function() {
      if(this.owner.name) {
        this.$store.commit('setLastBreadcrumb', this.owner.name);
        this.setPageTitle(this.owner.name);
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

#owner {
  min-height: 20vh;
  background: #FFF;
  border-radius: 5px;
  margin: 40px;
  padding: 0;
  border: 1px solid $border;

  .bottons {
    margin: 10px 10px 0 0;
    float: right;
  }
  .profile {
    padding: 30px 0 0 40px;
    border-bottom: 1px solid $border;

    p.type {
      display: inline-block;
      font-size: 14px;
      background: #000;
      color: #FFF;
      padding: 5px 10px;
    }
    h1 {
      margin:  10px 0 15px 0;
      font-size: 24px;
      font-weight: normal;
    }
    p.status {
      font-size: 14px;
      margin: 0 0 30px 0;
      vertical-align: middle;

      .el-tag {
        margin-left: 10px;
      }
    }
  }
  h2 {
    margin: 30px 0 20px 0;
    font-size: 16px;
    font-weight: normal;
  }
  .basic, .cuona, .other {
    padding: 0 40px 30px 40px;
    border-bottom: 1px solid $border;

    p {
      font-size: 14px;
      border-bottom: 1px solid $border;
      span {
        padding: 3px 6px;
        &.label {
          display: inline-block;
          background: #EEE;
          width: 150px;
          margin-right: 5px;
        }
        &.value {

        }
      }
    }
  }
}

</style>
